<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>De volta às origens</h2>
          <p>
            Em 1985, Zé Mineiro, após a venda da unidade de Planaltina (DF),
            abre uma fábrica de sabão. Três anos se passam e a paixão pelo setor
            da carne bovina fala mais alto, motivando a aquisição de uma pequena
            unidade, com capacidade de 60 bois por dia, na cidade de Luziânia
            (GO).
          </p>
          <img
            src="../assets/img/1988/1988-1.jpg"
            alt=""
            @click="showMultiple(0)"
          />
        </div>
        <div class="formato__warpper__item--black">
          <h2>A PRATICIDADE DO FORNO DE MICRO-ONDAS</h2>
          <p>
            Outro eletrodoméstico que mudaria a vida das refeições em casa nos
            anos 1980 foi o <strong>forno de micro-ondas</strong>. Com esse novo
            aparelho, era possível sacar uma refeição completa do freezer e
            tê-la aquecida e pronta para consumo em poucos minutos, satisfazendo
            a demanda cada vez maior das pessoas em terem comida fácil em seus
            lares, sem precisar gastar tempo na cozinha.
          </p>
          <blockquote>
            Com o micro-ondas, se fecha uma tríade evolutiva que passa pelo
            resfriamento (geladeira) e o congelamento (freezer)”,
          </blockquote>
          <p>afirma o professor <strong>Fábio Bitelli.</strong></p>
          <div class="images">
            <img
              src="../assets/img/1988/1988-2.png"
              alt=""
              @click="
                openLink(
                  'https://acervo.estadao.com.br/publicados/1986/03/16/g/19860316-34062-nac-0205-fem-5-not-psqggkq.jpg'
                )
              "
            />
            <img
              src="../assets/img/1988/1988-3.png"
              alt=""
              @click="
                openLink(
                  'https://acervo.estadao.com.br/publicados/1983/10/30/g/19831030-33330-nac-0137-fem-13-not-wpeaqee.jpg'
                )
              "
            />
            <span
              ><i class="icon-eye"></i
              ><strong>clique nas imagens para ampliar</strong></span
            >
          </div>
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from "./Ano.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { defineComponent } from "vue";

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ["ano"],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, "_blank");
    },
    showMultiple(index) {
      this.imgsRef = [
        {
          src: require("@/assets/img/1988/1988-1-full.jpg"),
          title:
            "1988-Aquisição de uma pequena unidade, com capacidade de 60 bois por dia, na cidade de Luziânia (GO).",
        },
      ];
      this.indexRef = index; // index of imgList
      this.onShow();
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 100px;
    display: grid;
    grid-template-columns: 488px 525px;
    justify-content: space-between;
    gap: 10px;
    @include media("<=desktop") {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;

    &__item {
      position: relative;
      @include media("<=desktop") {
        padding: 0 20px;
      }
      &--image {
        display: grid;
        position: relative;
        grid-template-columns: 1fr 1fr;
        max-height: 705px;
        padding-top: 26px;
        margin-left: -110px;
        @include media("<=desktop") {
          grid-template-columns: 1fr;
          margin-left: 0;
        }

        .span2 {
          grid-column: span 2;
          margin-top: 20px;
        }
        .fistItem {
          grid-column: 2;
          margin-left: -100px;
        }
        .secondItem {
          margin-top: -50px;
        }
        .terceiroItem {
          margin-top: 30px;
          margin-left: 20px;
        }
        .negativo {
          margin-left: -90px;
          margin-top: auto;
        }
        span {
          position: absolute;
          left: -70px;
          bottom: 50px;
          width: 65px;
          color: color(cBlue4);
          strong {
            color: color(cBlue4);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cGreen);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }
      img {
        cursor: pointer;
      }

      &--black {
        margin-left: 5rem;
        padding-block: 50px;
        @include media("<=desktop") {
          background: color(cBlue5);
          margin: 0;
          padding: 30px 20px;
        }
        .images {
          position: relative;

          span {
            position: absolute;
            left: -150px;
            top: 50px;
            width: 65px;
            color: color(cBLue6);

            @include media("<=desktop") {
              position: initial;
            }

            strong {
              color: color(primary);
              font-family: font(primary);
              font-size: 0.75rem;
              font-style: normal;
              font-weight: 400;
              line-height: 116.5%;
              background: color(cBLue6);
            }
            i {
              display: block;
              font-size: 1.3rem;
            }
          }
        }
        img {
          margin-top: 30px;
          cursor: pointer;
          &:nth-child(1) {
            margin-left: -50px;
          }
          &:nth-child(2) {
            margin-left: auto;
            display: block;
            margin-top: -100px;
          }
        }
        p {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
          max-width: 371px;
          margin: 0 auto;
        }
        h2 {
          color: color(cWhite);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          max-width: 371px;
          margin: 0 auto;
          margin-bottom: 10px;
        }
        blockquote {
          color: color(cBlue);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          position: relative;
          max-width: 370px;
          margin: 10px auto;
          &::before {
            content: "\e901";
            font-family: "icomoon" !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 5px;
          }
        }
      }
    }
    &::after {
      content: "";
      background: color(cBlue5);
      width: 45%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media("<=desktop") {
        display: none;
      }
    }
  }
}
</style>
